<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :formInputs="formInputs"
      :checkAlerts="true"
      primaryKey="id"
    />
</template>

<script>
import CrudBase from "../../../../components/crud/CrudBase";
import {
  schemaBooleanSelect,
  schemaTextField
} from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";
export default {
  name: "MotivoProduto",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/sac/ticket/motivo/produto",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRICAO", field: "descricao", sortable: false },
        { label: "PERMITE OBSERVACAO", field: "permite_observacao", sortable: false, representedAs: (row) => yesNoRepresentation(row.permite_observacao) },
        { label: "PADRAO", field: "padrao", sortable: false, representedAs: (row) => yesNoRepresentation(row.padrao) },
      ],
      formInputs: {
        descricao: schemaTextField('Descrição', true, 6),
        obrigatorio: schemaBooleanSelect('Obrigatorio', 1, 4, true),
        padrao: schemaBooleanSelect('Padrão', 1, 4, true),
      },
    };
  },
};
</script>
